export type { ComingSoonProps } from "./coming-soon";
export { ComingSoon } from "./coming-soon";
